module.exports = __webpack_public_path__ + "img/breadfruit-350x184.8c8d883e.jpg";